import axios from 'axios';
// import { defaultErrorMessage } from '../../strings';

// Uncomment the code
export async function Api(params) {
  let defaultErrorMessage = 'Error';
  try {
    const { method = 'get', endpoint = '', payload = null, headers = {}, formData = null } = params;

    let config = {
      method,
      url: `${process.env.REACT_APP_API_BASE_URL}${endpoint}`,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        ...headers,
      },
    };

    if (payload) config.data = payload;
    if (formData) config.formData = formData;

    const response = await axios(config);

    return response.data;
  } catch (error) {
    throw new Error(error.response.data.message || defaultErrorMessage);
  }
}
